import { FC } from 'react';
import { Field, useField } from 'formik';
import styles from './Inputs.module.scss';

export interface SelectFieldProps {
  label?: string;
  name: string;
  options: any[];
}

const SelectField: FC<SelectFieldProps> = ({ label, options, ...props }) => {
  const [field, meta, helpers] = useField(props);
  return (
    <div className={styles.formControl}>
      {label && <label htmlFor={props.name}>{label}</label>}
      <Field as='select' name={props.name}>
        {options.map((item) => (
          <option key={item.value || item} value={item.value || item}>
            {item.label || item}
          </option>
        ))}
      </Field>
    </div>
  );
};

export default SelectField;
